import { Component } from '@angular/core';

@Component({
  selector: 'team',
  templateUrl: 'team.component.html',
  styleUrls: ['team.component.scss']
})
export class TeamComponent { }
